import { Controller } from "@hotwired/stimulus"

// En el grupo de suppliers duplicados:
//  - Al seleccionar un radio "Canonical", deshabilita el checkbox "Mergear"
//    de la misma fila (no tiene sentido mergear el canonical hacia sí mismo)
//  - Y destilda el checkbox si estaba marcado
export default class extends Controller {
  static targets = ["row", "externalId"]

  connect() {
    this.update()
  }

  update() {
    this.rowTargets.forEach(row => {
      const radio = row.querySelector('input[type="radio"][name="canonical_id"]')
      const cb = row.querySelector('input[type="checkbox"][name="duplicate_ids[]"]')
      if (radio && cb) {
        if (radio.checked) {
          cb.checked = false
          cb.disabled = true
        } else {
          cb.disabled = false
        }
      }
    })
  }

  // Cuando el operador elige un canonical externo desde el datalist,
  // extraer el ID y guardarlo en el hidden + reset de los checkboxes
  // (el canonical externo no está en este grupo).
  externalSelected(event) {
    const value = event.target.value
    if (!value) {
      this.externalIdTarget.value = ""
      return
    }
    // Buscar la option exacta en el datalist global
    const datalist = document.getElementById("all-suppliers-datalist")
    const option = Array.from(datalist?.options || []).find(o => o.value === value)
    if (option) {
      this.externalIdTarget.value = option.dataset.id || ""
      // Permitir checkear TODAS las filas del grupo como duplicates (porque
      // el canonical ya no está en el grupo)
      this.rowTargets.forEach(row => {
        const cb = row.querySelector('input[type="checkbox"][name="duplicate_ids[]"]')
        if (cb) cb.disabled = false
      })
    }
  }
}
